import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Stack, StatusPill, Typography } from '@lyearn/ui';
import { QuestionTypeEnum } from '@/types/schema';

import { QuestionError } from '../Editor/QuestionError';
import { getEditorContainerStyles } from '../Editor/styles';
import RemoveImageActionMenu from '../RemoveImageActionMenu';
import { QuestionEditorContainerProps } from './types';

const QuestionEditorContainer = (props: React.PropsWithChildren<QuestionEditorContainerProps>) => {
  const { t } = useTranslation();
  const { children, error, maxWidth = 62, questionLabel, viewMode, question, onChange } = props;
  const showInactivePill = viewMode === 'view' && question.isActive === false;

  const onRemoveImage = useCallback(() => {
    onChange({
      ...question,
      attachments: { set: [] },
      imageHotspotComponents: { set: [] },
    });
  }, [onChange, question]);

  return (
    <Box className={cn('mx-auto w-full py-16 px-34', getEditorContainerStyles({ maxWidth }))}>
      <QuestionError error={error} />
      {showInactivePill ? (
        <StatusPill
          appearance="secondary"
          className="label-02 mb-20 h-32 px-12 ms-12"
          label={t('Common:Inactive')}
          size={'large'}
          variant="light"
        />
      ) : null}
      <Stack alignItems="center" justifyContent="between">
        <Typography as="p" className="px-16" color="text-text-placeholder" variant="label-caps">
          {questionLabel}
        </Typography>
        {question.questionType === QuestionTypeEnum.ImageHotspot ? (
          <Box className="-my-10">
            <RemoveImageActionMenu onRemoveImage={onRemoveImage} />
          </Box>
        ) : null}
      </Stack>
      {children}
    </Box>
  );
};

export default QuestionEditorContainer;
